import { render, staticRenderFns } from "./batchRegistration.vue?vue&type=template&id=e4a021d6&scoped=true"
import script from "./batchRegistration.vue?vue&type=script&lang=js"
export * from "./batchRegistration.vue?vue&type=script&lang=js"
import style0 from "./batchRegistration.vue?vue&type=style&index=0&id=e4a021d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a021d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a021d6')) {
      api.createRecord('e4a021d6', component.options)
    } else {
      api.reload('e4a021d6', component.options)
    }
    module.hot.accept("./batchRegistration.vue?vue&type=template&id=e4a021d6&scoped=true", function () {
      api.rerender('e4a021d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/problemList/component/batchRegistration.vue"
export default component.exports